import { t as throttle } from "./lodash-utils.js";
import { s as slideUp, a as slideDown } from "./slide.js";
import { p as pubsub } from "./shared-utilities.js";
import { l as layout } from "./layout-store.js";
const calculateMilliseconds = (hours, mins = 0, seconds = 0) => (hours * 60 * 60 + mins * 60 + seconds) * 1e3;
class CreateNotification {
  constructor(elementId, type = "bar", timeIn = 0, trigger = false) {
    this.type = "bar";
    this.handleCloseBar = () => {
      this.notificationEl.parentNode.classList.remove("bar-open");
      document.body.style.removeProperty("--height-screen");
      document.body.style.removeProperty("--notificationOffset");
      slideUp(this.notificationEl, { duration: this.animationTiming }, () => {
        pubsub.emit("notificationBarState");
        pubsub.off("mainNavOpen", this.handleCloseBar);
        pubsub.off("megaMenuOpen", this.handleCloseBar);
      });
    };
    this.handleCloseNotification = () => {
      this.open = false;
      const timestamp = Date.now();
      const storage = window.localStorage;
      storage.setItem(`notification-${this.elementId}`, timestamp.toString());
      if (this.type === "bar") {
        this.handleCloseBar();
      }
      if (this.type == "fade" || this.type == "age-gate") {
        this.notificationEl.classList.add("fade-out");
        this.notificationEl.classList.remove("fade-in");
      }
      document.dispatchEvent(
        new CustomEvent("notificationClose", {
          detail: {
            elementId: this.elementId,
            type: this.type
          }
        })
      );
      document.body.style.removeProperty("overflow");
      setTimeout(() => {
        this.notificationEl.remove();
      }, this.animationTiming);
    };
    this.elementId = elementId;
    this.type = type;
    this.notificationEl = document.getElementById(elementId);
    this.animationTiming = 300;
    this.closeButton;
    this.open = false;
    this.timeout = calculateMilliseconds(24);
    if (this.notificationEl) {
      this.timein = this.notificationEl.dataset.timein ? calculateMilliseconds(
        0,
        0,
        Number(this.notificationEl.dataset.timein)
      ) : timeIn ? timeIn : 0;
      if (this.checkCookieStatus()) {
        this.notificationEl.remove();
      } else {
        setTimeout(() => {
          this.initializeEvents();
        }, this.timein);
      }
    }
    this.canOpen = this.timein && this.timein > 0 ? false : true;
    this.trigger = trigger;
  }
  checkCookieStatus() {
    const storage = window.localStorage;
    const originalCookie = storage.getItem(`notification-${this.elementId}`);
    const now = Date.now();
    if (originalCookie !== null && originalCookie !== void 0 && Number(originalCookie) + this.timeout > now) {
      return true;
    }
    return false;
  }
  handleOpenBar() {
    this.notificationEl.parentNode.classList.add("bar-open");
    console.log("bar-open");
    slideDown(this.notificationEl, { duration: this.animationTiming }, () => {
      document.body.style.setProperty(
        "--height-screen",
        `calc(100vh - ${this.notificationEl.offsetHeight}px)`
      );
      document.body.style.setProperty(
        "--notificationOffset",
        `${this.notificationEl.offsetHeight}px`
      );
      pubsub.emit("notificationBarState");
    });
    pubsub.on("mainNavOpen", this.handleCloseBar);
    pubsub.on("megaMenuOpen", this.handleCloseBar);
  }
  initializeEvents() {
    if (this.canOpen) {
      if (this.type === "bar") {
        this.handleOpenBar();
      } else if (this.type === "modal") {
        layout.modal.value = this.elementId;
        this.notificationEl.addEventListener(
          "close",
          this.handleCloseNotification
        );
      } else if (this.type === "fade") {
        this.notificationEl.classList.remove("hidden");
        this.notificationEl.classList.add("fade-in");
        this.notificationEl.classList.add("active");
      }
      this.closeButton = this.notificationEl.querySelector(".js-close");
      if (this.closeButton) {
        this.closeButton.addEventListener(
          "click",
          this.handleCloseNotification
        );
      }
      document.dispatchEvent(
        new CustomEvent("notificationOpen", {
          detail: {
            elementId: this.elementId,
            type: this.type
          }
        })
      );
    } else {
      setTimeout(() => {
        this.canOpen = true;
        this.initializeEvents();
      }, this.timein);
    }
    if (this.notificationEl.getAttribute("hide-scroll")) {
      document.addEventListener(
        "scroll",
        throttle((e) => {
          if (window.scrollY > 400) {
            this.handleCloseNotification();
          }
        }, 200)
      );
    }
    if (this.trigger) {
      const triggerEl = this.notificationEl.querySelector("button");
      if (triggerEl) {
        triggerEl.addEventListener("click", () => {
          this.handleCloseNotification();
        });
      }
    }
  }
}
export {
  CreateNotification as C
};
